import { Routes, Route } from 'react-router-dom'
import { ReactiveBackground } from './components/global'
import RouteTransitionWrapper from './components/RouteTransitionWrapper'
import RouteTransitionOverlay from './components/RouteTransitionOverlay'
import domainSkins from './data/domainSkins.json'
import HomePage from './pages/HomePage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import ContactPage from './pages/ContactPage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import SolutionsPage from './pages/SolutionsPage'
import EnterprisePage from './pages/EnterprisePage'
import GovernancePage from './pages/GovernancePage'
import InvestorsPage from './pages/InvestorsPage'

/* Domain-level skin — per-route overrides are handled inside ReactiveBackground
   using the `routes` map in domainSkins.json */
const domainSkin = (domainSkins as Record<string, unknown>)['lukhas.com']

function App() {
  return (
    <div className="min-h-screen bg-consciousness-deep text-awareness-silver">
      {/* Fixed background layer — persists across all routes (outside <Routes>) */}
      <ReactiveBackground
        skin={domainSkin as Parameters<typeof ReactiveBackground>[0]['skin']}
      />
      {/* Cross-route slide overlay — shows page label on navigation */}
      <RouteTransitionOverlay />
      <RouteTransitionWrapper>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/enterprise" element={<EnterprisePage />} />
          <Route path="/governance" element={<GovernancePage />} />
          <Route path="/investors" element={<InvestorsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cookies" element={<CookiePolicyPage />} />
        </Routes>
      </RouteTransitionWrapper>
    </div>
  )
}

export default App
